<template>
  <el-col class="menu">
    <el-menu mode="horizontal">
      <el-submenu index="1" popper-class="trans-data" v-if="menuVisible('data',loginUserRoleId)">
        <template slot="title" v-if="menuVisible('data',loginUserRoleId)"><div>データ登録</div></template>
        <el-menu-item v-if="menuVisible('flight-data',loginUserRoleId)"><router-link to="/data/flight-data">運航データ</router-link></el-menu-item>
        <el-menu-item v-if="menuVisible('hangar-usages-data',loginUserRoleId)"><router-link to="/data/hangar-usages-data">格納庫使用データ</router-link></el-menu-item>
        <el-menu-item v-if="menuVisible('merge-data',loginUserRoleId)"><router-link to="/data/merge-data">着離陸・入出庫データ</router-link></el-menu-item>
        <el-menu-item v-if="menuVisible('landing-passengers-data',loginUserRoleId)"><router-link to="/data/landing-passengers-data">着陸時有償旅客データ</router-link></el-menu-item>
        <el-menu-item v-if="menuVisible('takeoff-passengers-data',loginUserRoleId)"><router-link to="/data/takeoff-passengers-data">離陸時有償旅客データ</router-link></el-menu-item>
      </el-submenu>
      <el-submenu index="2" popper-class="calc" v-if="menuVisible('calculation',loginUserRoleId)">
        <template slot="title" v-if="menuVisible('calculation',loginUserRoleId)"><div>料金計算</div></template>
        <el-menu-item><router-link to="/calculation/fees-for-weight-and-noise">着陸料［重量・騒音］</router-link></el-menu-item>
        <el-menu-item><router-link to="/calculation/fees-for-paid-passengers">着陸料［有償旅客］</router-link></el-menu-item>
        <el-menu-item><router-link to="/calculation/fees-for-stop">停留料</router-link></el-menu-item>
        <el-menu-item><router-link to="/calculation/fees-for-security">保安料</router-link></el-menu-item>
      </el-submenu>
      <el-submenu index="3" popper-class="invoice" v-if="menuVisible('invoice',loginUserRoleId)">
        <template slot="title" v-if="menuVisible('invoice',loginUserRoleId)"><div>請求書管理</div></template>
        <el-menu-item v-if="menuVisible('invoice-operation',loginUserRoleId)"><router-link to="/invoice/invoice-operation">請求書一覧</router-link></el-menu-item>
        <el-menu-item v-if="menuVisible('invoice-inquiry',loginUserRoleId)"><router-link to="/invoice/invoice-inquiry">請求書照会</router-link></el-menu-item>
      </el-submenu>
      <el-menu-item v-if="menuVisible('simulation',loginUserRoleId)"><div>料金シミュレーション</div></el-menu-item>
      <el-submenu index="5" popper-class="master-data" v-if="menuVisible('master',loginUserRoleId)">
        <template slot="title" v-if="menuVisible('master',loginUserRoleId)"><div>マスタ管理</div></template>
        <el-menu-item><router-link to="/master/registration-symbol-master">登録機マスタ</router-link></el-menu-item>
        <el-menu-item><router-link to="/master/customer-master">顧客マスタ</router-link></el-menu-item>
        <el-menu-item><router-link to="/master/airport-master">空港マスタ</router-link></el-menu-item>
        <el-menu-item><router-link to="/master/user-master">担当者マスタ</router-link></el-menu-item>
      </el-submenu>
            <el-submenu index="6" popper-class="fee-master" v-if="menuVisible('fee_master',loginUserRoleId)">
        <template slot="title" v-if="menuVisible('fee_master',loginUserRoleId)"><div>料金管理</div></template>
        <el-menu-item><router-link to="/fee-master/fees-for-weight-and-noise">着陸料［重量・騒音］</router-link></el-menu-item>
        <el-menu-item><router-link to="/fee-master/fees-for-paid-passengers">着陸料［有償旅客］</router-link></el-menu-item>
        <el-menu-item><router-link to="/fee-master/fees-for-stop">停留料</router-link></el-menu-item>
        <el-menu-item><router-link to="/fee-master/fees-for-security">保安料</router-link></el-menu-item>
      </el-submenu>
    </el-menu>
  </el-col>
</template>

<script>
export default {
  data () {
    return {
      loginUserRoleId: this.$loginuser.get('role_id')
    }
  },
  methods: {
    logOff: function (e) {
      this.$session.destroy()
      this.$router.push({ path: '/' })
    },
    menuVisible: function (menuId, roleId) {
      var roleIdList = []

      // 20220509 髙森 airport_user00（空港業務承認者）追加
      if (menuId === 'data') { roleIdList = ['admin', 'airport_user00', 'airport_user01', 'airport_user02', 'airport_user03', 'airline_user01', 'airline_user02'] }
      if (menuId === 'flight-data') { roleIdList = ['admin', 'airport_user00', 'airport_user01', 'airport_user02'] }
      if (menuId === 'hangar-usages-data') { roleIdList = ['admin', 'airport_user00', 'airport_user01', 'airport_user02', 'airport_user03'] }
      if (menuId === 'merge-data') { roleIdList = ['admin', 'airport_user00', 'airport_user01'] }
      if (menuId === 'landing-passengers-data') { roleIdList = ['admin', 'airport_user00', 'airport_user01', 'airline_user01', 'airline_user02'] }
      if (menuId === 'takeoff-passengers-data') { roleIdList = ['admin', 'airport_user00', 'airport_user01', 'airline_user01', 'airline_user02'] }

      if (menuId === 'calculation') { roleIdList = ['admin', 'airport_user00', 'airport_user01'] }

      if (menuId === 'invoice') { roleIdList = ['admin', 'airport_user00', 'airport_user01', 'airline_user01'] }
      if (menuId === 'invoice-operation') { roleIdList = ['admin', 'airport_user00', 'airport_user01'] }
      if (menuId === 'invoice-inquiry') { roleIdList = ['admin', 'airport_user00', 'airport_user01', 'airline_user01'] }

      if (menuId === 'simulation') { roleIdList = [] }

      if (menuId === 'master') { roleIdList = ['admin'] }

      if (menuId === 'fee_master') { roleIdList = ['admin'] }
      return roleIdList.includes(roleId)
    }
  }
}
</script>
<style lang="scss" scoped>
.menu {
  flex-grow: 1;
  height: 100%;
  width: max-content;
  display: flex;
  overflow-y: auto;
  ::v-deep ul.el-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom-style: none;
    .el-menu-item,
    .el-submenu__title {
      color: black;
      background-color: var(-background-color);
      border-bottom-style: none;
      line-height: normal;
      height: auto;
      &:hover {
        >div {
          padding-bottom: calc(0.5em - 0.5rem);
          border-bottom: solid 0.5rem var(--primary-border-color);
        }
      }
      a {
        text-decoration: none;
      }
      >div {
        padding: 0.5em 0;
        display: inline-block;
        box-sizing: border-box;
      }
    }
    .el-submenu.is-opened {
      .el-submenu__title {
        >div {
          padding-bottom: calc(0.5em - 0.5rem);
          border-bottom: solid 0.5rem var(--primary-border-color);
        }
      }
    }
  }
}
</style>
<style lang="scss">
div.el-menu--horizontal {
  font-size: 120%;
  .el-menu.el-menu--popup {
    padding-top: 0.5rem;
    .el-menu-item {
      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }
  &.trans-data,
  &.calc,
  &.invoice,
  &.master-data,
  &.fee-master {
    position: fixed !important;
    top: var(--header-height) !important;
    width: 100% !important;
    left: 0 !important;
    .el-menu.el-menu--popup {
      margin-top: 0;
      background-color: #555;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1.2rem 0;
      .el-menu-item {
        color: white;
        background-color: #555;
        // margin-top: 0.5rem;
        // margin-bottom: 0.5rem;
        margin-left: 1rem;
        margin-right: 1rem;
        :hover {
          color: black;
          background-color: white;
          margin-top: -0.5rem;
          margin-bottom: -0.5rem;
          margin-left: -1.5rem;
          margin-right: -1.5rem;
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
          padding-left: 1.5rem;
          padding-right: 1.5rem;
        }
      }
    }
  }
}
</style>
